export default {
  ONF: 'onf',
  COPRODUCTION: 'coproduction',
  ACQUISITION: 'acquisition'
}
